import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './MultiCheckbox.css'

const MultiCheckbox = ({label, Items, selectedstate, setSelecetedState, checkboxstyle}) => {

    function handleCheckbox(id) {
        if (selectedstate.find(z => parseInt(z) === id)) {
            const newdata = selectedstate.filter(x => parseInt(x) !== id)
            setSelecetedState(newdata)
        }else{
            setSelecetedState([...selectedstate, id])
        }
    }

    return (
        <div className='multi-checkbox' style={checkboxstyle? checkboxstyle : {}}>
            <div className="label"><label>{label && label}</label></div>
            <div className="checkbox-area">
            {Items && selectedstate && Items.length > 0 && 
                Items.map((item, i) => {
                    if (selectedstate.find(x => parseInt(x) === item.id)) {
                        return(
                            <div key={`CHECKBOX${i}`} onClick={() => handleCheckbox(item.id)} className="eachceckbox" title={item.title && item.title}>
                                <div className="empty-hole active">
                                    <FontAwesomeIcon icon={faCheck} />
                                </div>
                                <div className="checkbox-label">{item.label && item.label}</div>
                            </div>
                        )
                    }else{
                        return(
                            <div key={`CHECKBOX${i}`} onClick={() => handleCheckbox(item.id)} className="eachceckbox" title={item.title && item.title}>
                                <div className="empty-hole">
                                </div>
                                <div className="checkbox-label">{item.label && item.label}</div>
                            </div>
                        )
                    }
                })
            }

            </div>
        </div>
    )
}

export default MultiCheckbox
